/**
 * Builders for the `[[SELECTED:...]]` synthetic chat-turn payloads.
 *
 * Phase 4 — material picker round-trip.
 * Phase 8 — photos picker round-trip.
 *
 * The server-side parsers live in `api/handlers/chat_stream.py`; the
 * client just constructs the prefix string + appends a human-readable
 * tail so the archived chat reads naturally.
 */

/** Phase 4 — `[[SELECTED:category=<group>;option_id=<id>]] <tail>` */
export function buildSelectedMaterialTurn(args: {
  optionGroupId: string;
  optionId: string;
  displayName: string;
}): string {
  return (
    `[[SELECTED:category=${args.optionGroupId};option_id=${args.optionId}]] ` +
    `I'll go with ${args.displayName}.`
  );
}

/** Phase 8 — `[[SELECTED:photos=<id>,<id>;anchor_id=<id>]] <tail>` */
export function buildSelectedPhotosTurn(args: {
  photoIds: string[];
  anchorId: string;
}): string {
  return (
    `[[SELECTED:photos=${args.photoIds.join(",")};anchor_id=${args.anchorId}]] ` +
    `Apply this measurement to the selected photos.`
  );
}

/**
 * Phase 21 — `[[SELECTED:render_photo=<id>;prompt=<prompt>]] <tail>`
 *
 * The customer picked which photo to render (from the picker Stella
 * raised via `[[RENDER_SELECT:…]]`). The prompt is carried back verbatim
 * so the server can dispatch the render deterministically without a
 * Bedrock round-trip. `prompt` goes last because it may contain `;`.
 */
export function buildSelectedRenderPhotoTurn(args: {
  photoId: string;
  prompt: string;
}): string {
  return (
    `[[SELECTED:render_photo=${args.photoId};prompt=${args.prompt}]] ` +
    `Use this photo.`
  );
}
